import { render, staticRenderFns } from "./AlbumShuffleZone.vue?vue&type=template&id=59fdf00a&scoped=true&"
import script from "./AlbumShuffleZone.vue?vue&type=script&lang=js&"
export * from "./AlbumShuffleZone.vue?vue&type=script&lang=js&"
import style0 from "./AlbumShuffleZone.vue?vue&type=style&index=0&id=59fdf00a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59fdf00a",
  null
  
)

export default component.exports